import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Database03 = function Database03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14 20c0 1.1046-.8954 2-2 2s-2-.8954-2-2m4 0c0-1.1046-.8954-2-2-2m2 2h7m-11 0c0-1.1046.8954-2 2-2m-2 2H3m9-2v-4m9-9c0 1.6569-4.0294 3-9 3S3 6.6569 3 5m18 0c0-1.6568-4.0294-3-9-3S3 3.3432 3 5m18 0v6c0 1.66-4 3-9 3M3 5v6c0 1.66 4 3 9 3"
    })
  }));
};
export default Database03;